/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiIcon, EuiTextColor } from '@elastic/eui'

import type { RegionInfo } from '@modules/cloud-api/v1/types'
import { CuiLink } from '@modules/cui/Link'

import { hostsAllocatorsUrl } from '../../../lib/urlBuilder'

import { getAllocatorCounts } from './lib/regionHealth'

import type { FunctionComponent } from 'react'

type Props = {
  region: RegionInfo
}

const RegionAllocatorsStatus: FunctionComponent<Props> = ({ region }) => {
  const { connected, disconnected } = getAllocatorCounts({ region })
  const hasBothConnectedAndDisconnected = connected > 0 && disconnected > 0

  return (
    <EuiFlexGroup gutterSize='xs' alignItems='center' responsive={false}>
      {connected > 0 && (
        <EuiFlexItem grow={false}>
          <EuiFlexGroup gutterSize='xs' alignItems='center' responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiIcon type='dot' color='success' />
            </EuiFlexItem>

            <EuiFlexItem grow={false}>
              <CuiLink to={`${hostsAllocatorsUrl(region.region_id)}?q=connected:y`}>
                {connected}
              </CuiLink>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      )}

      {hasBothConnectedAndDisconnected && (
        <EuiFlexItem grow={false}>
          <EuiTextColor color='subdued'>/</EuiTextColor>
        </EuiFlexItem>
      )}

      {disconnected > 0 && (
        <EuiFlexItem grow={false}>
          <EuiFlexGroup gutterSize='xs' alignItems='center' responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiIcon type='dot' color={region.allocators.healthy ? 'warning' : 'danger'} />
            </EuiFlexItem>

            <EuiFlexItem grow={false}>
              <CuiLink to={`${hostsAllocatorsUrl(region.region_id)}?q=connected:n`}>
                {disconnected}
              </CuiLink>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      )}
    </EuiFlexGroup>
  )
}

export default RegionAllocatorsStatus
